import { IEntityDataService } from "@pit/core-data";
import { DtoShipment, IDtoShipment, IDtoShipmentList, IDtoStatsDepotShipments } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoShipmentEntityDataService extends IEntityDataService<IDtoShipment> {

    getShipmentByShipmentNumber$(shipmentNumber: string): Observable<IDtoShipment>;
    getShipmentByShipmentNumberAsync(shipmentNumber: string): Promise<IDtoShipment>;

    getShipmentByShipmentNumberForMandator$(mandator: string, shipmentNumber: string): Observable<IDtoShipment>;
    getShipmentByShipmentNumberForMandatorAsync(mandator: string, shipmentNumber: string): Promise<IDtoShipment>;

    getShipmentsForDate$(shipmentDate: Date): Observable<IDtoShipment[]>;
    getShipmentsForDateAsync(shipmentDate: Date): Promise<IDtoShipment[]>;

    getShipmentsForDevice$(deviceId: string): Observable<IDtoShipment[]>;
    getShipmentsForDeviceAsync(deviceId: string): Promise<IDtoShipment[]>;

    removeShipmentsFromDevice$(deviceId: string, shipmentIds: string[]): Observable<boolean>;
    removeShipmentsFromDeviceAsync(deviceId: string, shipmentIds: string[]): Promise<boolean>;

    removeAllShipmentsFromDevice$(deviceId: string): Observable<boolean>;
    removeAllShipmentsFromDeviceAsync(deviceId: string): Promise<boolean>;

    getShipmentsToBookToDepot$(numberDepot: string): Observable<IDtoShipment[]>
    getShipmentsToBookToDepotAsync(numberDepot: string): Promise<IDtoShipment[]>

    getActiveShipmentsForUser$(userName: string): Observable<IDtoShipment[]>;
    getActiveShipmentsForUserAsync(userName: string): Promise<IDtoShipment[]>;

    getActiveShipmentsForDepot$(depotNumber: string): Observable<IDtoShipment[]>;
    getActiveShipmentsForDepotAsync(depotNumber: string): Promise<IDtoShipment[]>;

    getShipmentsToReturnForDepot$(depotNumber: string, includeInDelivery?: boolean): Observable<IDtoShipment[]>;
    getShipmentsToReturnForDepotAsync(depotNumber: string, includeInDelivery?: boolean): Promise<IDtoShipment[]>;

    getShipmentsToReturnForDevice$(deviceId: string): Observable<IDtoShipment[]>;
    getShipmentsToReturnForDeviceAsync(deviceId: string): Promise<IDtoShipment[]>;

    getShipmentListItemsActiveForDepot$(depotNumber: string): Observable<IDtoShipmentList[]>;
    getShipmentListItemsActiveForDepotAsync(depotNumber: string): Promise<IDtoShipmentList[]>;

    getShipmentListItemsReturnsForDepot$(depotNumber: string, includeInDelivery?: boolean): Observable<IDtoShipmentList[]>;
    getShipmentListItemsReturnsForDepotAsync(depotNumber: string, includeInDelivery?: boolean): Promise<IDtoShipmentList[]>;

    getShipmentListItemsLostForDepot$(depotNumber: string): Observable<IDtoShipmentList[]>;
    getShipmentListItemsLostForDepotAsync(depotNumber: string): Promise<IDtoShipmentList[]>;

    getDepotShipmentsStatsForMandator$(mandator: string, depotNumber: string): Observable<IDtoStatsDepotShipments[]>;
    getDepotShipmentsStatsForMandatorAsync(mandator: string, depotNumber: string): Promise<IDtoStatsDepotShipments[]>;

}
